export default __webpack_public_path__ + "media/sarthi.76f4de73.png";